import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { LogintemplateComponent } from './logintemplate/logintemplate.component';
import { DashboardComponent } from './layout/dashboard/dashboard.component';
import { ExcursionComponent } from './excursion/excursion.component';
import { EmailComponent } from './layout/email/email.component';
import { DailyreportComponent } from './dailyreport/dailyreport.component';
import { DashboardsettingComponent } from './dashboardsetting/dashboardsetting.component';
import { HomeComponent } from './home/home.component';
import { AuthGuard } from './auth.guard'
import { TransferComponent } from './transfer/transfer.component';
import { SupplierConfirmationComponent } from './supplier-confirmation/supplier-confirmation.component';
import { ArrDepReportComponent } from './arr-dep-report/arr-dep-report.component';

const routes: Routes = [
  {path:'',component:LogintemplateComponent},
  {path:'login',component:LogintemplateComponent},
  {path:'supplier-confirmation', component:SupplierConfirmationComponent},
 
  {path:'webqnex',component:HomeComponent,children:[
    {path:'',component:DashboardComponent},
    {path:'dashboard',component:DashboardComponent},
    {path:'excursion',component:ExcursionComponent},
    {path:'daily_report',component:DailyreportComponent},
    {path:'dashboard_setting',component:DashboardsettingComponent},
    {path:'email',component:EmailComponent},
    {path:'transfer',component:TransferComponent},
    {path:'arr-dep-report',component:ArrDepReportComponent}
  ],canActivate: [AuthGuard]},

  
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { useHash: true })],
  exports: [RouterModule]
})
export class AppRoutingModule { }
